module.exports = "/_next/static/images/b86bd42c3c34be08c1c34fb7217f4a25-phone.svg.webp";